var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.promise.data && !_vm.promise.error)?_c('div',{staticClass:"notification is-primary"},[_vm._v("Loading")]):(_vm.notFound)?_c('not-found'):(_vm.promise.error)?_c('div',{staticClass:"notification is-danger"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }